import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';
import Link from 'core/components/Link';

import themePropTypes from 'core/utils/prop-types/theme';
import { buildDownloadFileName } from 'core/utils/url-helper';

import styles from './index.styl';

function Header(props, { webdavHost, host }) {
  const {
    downloadSrc,
    showDownloadIcon,
    toggleFullscreenHandler,
    isFullscreen,
    isDesktop,
    theme,
  } = props;

  const {
    controls: {
      gallery: {
        icons: {
          Close,
          Download,
          background: iconsBackground,
        },
      },
    },
  } = theme;

  const downloadable = showDownloadIcon && downloadSrc && (isDesktop || isFullscreen);

  return (
    <div className={styles.iconsContainer}>
      <style jsx>{`
        .${styles.icon}
          background ${isFullscreen ? 'rgba(0, 0, 0, .47)' : iconsBackground}
          transition opacity ${theme.animations.hover}
      `}</style>
      {downloadable &&
        <div className={styles.icon}>
          <Link
            to={(webdavHost || '') + downloadSrc}
            target='_blank'
            download={buildDownloadFileName(host, downloadSrc)}
          >
            <div className={styles.icon}>
              <Download />
            </div>
          </Link>
        </div>
      }
      {isFullscreen && (
        <div onClick={toggleFullscreenHandler} className={styles.icon}>
          <Close />
        </div>
      )}
    </div>
  );
}

Header.contextTypes = {
  host: PropTypes.string,
  webdavHost: PropTypes.string,
};

Header.propTypes = {
  downloadSrc: PropTypes.string,
  isFullscreen: PropTypes.bool,
  showDownloadIcon: PropTypes.bool,
  isDesktop: PropTypes.bool,
  toggleFullscreenHandler: PropTypes.func.isRequired,
  theme: themePropTypes(`
    {
      animations: {
        hover,
      },
      controls: {
        gallery: {
          icons: {
            Close,
            Download,
            background,
          },
        },
      },
    }
  `),
};

export default withBreakpoint(withTheme(Header));
